import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../../../services/apiClientService';
import { Routes } from '../../../routes/RouteConstants';
import useErrorHandler, { isBookingTooLate, isCouponRejected } from '../../../hooks/useErrorHandler';
import { useTenant } from '../../../contexts/TenantContext';

const useConfirmBooking = () => {
  const { tenantId } = useTenant();
  const [loading, setLoading] = useState(false);
  const { handleError } = useErrorHandler();
  const navigate = useNavigate();

  // With a coupon the backend checks it again and prices the booking on this moment. A coupon it
  // refuses refuses the confirmation too: the booking stays a pre-reservation, the snackbar says
  // why, and onCouponRejected lets the page drop the coupon so the guest can decide again.
  const confirmBooking = async (bookingId, couponCode, onCouponRejected) => {
    setLoading(true);

    try {
      const url = `/v1/tenants/${tenantId}/bookings/${bookingId}/confirm`;
      const response = await apiClient.put(url, couponCode ? { couponCode } : undefined);
      return response.data;
    } catch (error) {
      handleError(error, Routes.CONFIRM_BOOKING);
      // The deadline counts at the confirmation too (DECISIONS.md D30). The hold asked for in the
      // same click nearly always catches it first; this is the moment in between.
      if (isBookingTooLate(error)) {
        navigate(Routes.BOOKING, { replace: true });
      }
      if (isCouponRejected(error)) {
        onCouponRejected?.();
      }
    } finally {
      setLoading(false);
    }
  };

  return { confirmBooking, loading };
};

export default useConfirmBooking;
